import { useState, useEffect } from 'react';
import api from '@/lib/axios';
import { formatTelefon } from '@/lib/telefon';

export interface Adres {
  id: number;
  baslik?: string;
  ad: string;
  soyad: string;
  telefon: string;
  il: string;
  ilce: string;
  mahalle?: string;
  adres: string;
  posta_kodu?: string;
  varsayilan?: boolean;
}

export const bosAdresForm = {
  baslik: '',
  ad: '',
  soyad: '',
  telefon: '',
  il: '',
  ilce: '',
  mahalle: '',
  adres: '',
  posta_kodu: '',
  varsayilan: false,
};

export function useAdresler(aktif: boolean = true) {
  const [adresler, setAdresler] = useState<Adres[]>([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  const formatliAdresler = (liste: Adres[]) =>
    liste.map((a) => ({ ...a, telefon: formatTelefon(a.telefon || '') }));

  const getir = async () => {
    setYukleniyor(true);
    try {
      const res = await api.get('/kullanicilar/adresler');
      setAdresler(formatliAdresler(res.data));
    } catch {}
    setYukleniyor(false);
  };

  useEffect(() => {
    if (aktif) getir();
  }, [aktif]);

  const kaydet = async (form: typeof bosAdresForm, id: number | null): Promise<Adres | null> => {
    const temizForm = { ...form, telefon: form.telefon.replace(/\s/g, '') };
    try {
      if (id) {
        const res = await api.put(`/kullanicilar/adresler/${id}`, temizForm);
        const formatli = { ...res.data, telefon: formatTelefon(res.data.telefon || '') };
        setAdresler(p => p.map(a => {
          if (a.id === id) return formatli;
          if (form.varsayilan) return { ...a, varsayilan: false };
          return a;
        }));
        return formatli;
      } else {
        const res = await api.post('/kullanicilar/adresler', temizForm);
        const formatli = { ...res.data, telefon: formatTelefon(res.data.telefon || '') };
        setAdresler(p => {
          const guncellendi = form.varsayilan ? p.map(a => ({ ...a, varsayilan: false })) : [...p];
          return [...guncellendi, formatli];
        });
        return formatli;
      }
    } catch (err: any) {
      const msg = err.response?.data?.message;
      alert(typeof msg === 'object' ? msg?.message || 'Hata' : msg || 'Adres kaydedilemedi');
      return null;
    }
  };

  const sil = async (id: number): Promise<boolean> => {
    if (!confirm('Bu adresi silmek istiyor musunuz?')) return false;
    try {
      await api.delete(`/kullanicilar/adresler/${id}`);
      setAdresler(p => p.filter(a => a.id !== id));
      return true;
    } catch {
      return false;
    }
  };

  return { adresler, setAdresler, yukleniyor, getir, kaydet, sil };
}